const progresses = document.querySelectorAll('.product-progress-bar--wrapper .progressbar');
const progressTexts = document.querySelectorAll('.product-progress-bar--wrapper .progressbar-text');
const multiplicators = document.querySelectorAll('.culottes-multiplicator__container .unit-culotte'); 

let getQuantityInput = document.querySelector('.quantity__input').value;
let getQuantityInputAsNumber = parseInt(getQuantityInput, 10);

const getQuantityPlus = document.querySelector('.quantity__plus');
const getQuantityMinus = document.querySelector('.quantity__minus');

const themeDiscountOffers = window.theme.discountOffers;
const discountOffersSize = themeDiscountOffers.length;
const lastDiscountOffer = themeDiscountOffers[discountOffersSize - 1];

// Function to increment count
const handleIncrement = () => {
  getQuantityInputAsNumber++;
};

// Function to decrement count
const handleDecrement = () => {
  if (getQuantityInputAsNumber >= 2) {
    getQuantityInputAsNumber--;
  }
};

const handleMultiplicator = (element) => {
  getQuantityInputAsNumber = parseInt(element.dataset.treshold);
  getQuantityInput = parseInt(element.dataset.treshold);
  handleSelected(element)
};

const handleSelected = (element) => {
  multiplicators.forEach((multiplicator) => {
    multiplicator.classList.remove("selected");
  });
  element.classList.add("selected");
};

const handleQtyDisplay = () => {
  progresses.forEach((progress, index) => {
    let progressTreshold = themeDiscountOffers[index][0];
    let start = 0;
    if (index > 0) start = themeDiscountOffers[index - 1][0];
    let range = progressTreshold - start;   
    let progressValue = 0;
    let textValue = themeDiscountOffers[index][2];
    
    if (getQuantityInputAsNumber >= progressTreshold) {
      progressValue = 100;
    } else {
      if (getQuantityInputAsNumber >= start) {
        progressValue = (100 / range) * (getQuantityInputAsNumber - start);
      } else {
        progressValue = 0;
      }
    }

    if (progressValue == 100) {
      textValue = themeDiscountOffers[index][2] + ' ✓';
      handleSelected(multiplicators[index + 1]);
    }
    
    progress.value = progressValue;
    progressTexts[index].innerHTML = textValue;
  });

  if (getQuantityInputAsNumber < themeDiscountOffers[0][0]) {
    handleSelected(multiplicators[0]);
  }
}

handleQtyDisplay();

multiplicators.forEach((element) => {
  element.addEventListener('click', () => {
    handleMultiplicator(element);
    handleQtyDisplay();
  });
});

getQuantityPlus.addEventListener('click', () => {
  if (getQuantityInputAsNumber >= 0 || getQuantityInputAsNumber <= lastDiscountOffer[0]) {
    handleIncrement();
    handleQtyDisplay();
  }
});

getQuantityMinus.addEventListener('click', () => {
  if (getQuantityInputAsNumber >= 0 || getQuantityInputAsNumber <= lastDiscountOffer[0]) {
    handleDecrement();
    handleQtyDisplay();
  }
});